var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPurpleGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5207_281184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.48064L5.31777 10.7772C2.27251 14.7231 0.457389 19.6395 0.457389 24.9806C0.457389 37.9597 11.1315 48.4783 24.2995 48.4783C28.1488 48.4783 31.7814 47.5743 35 45.9773L31.3553 39.6017C29.2152 40.6078 26.8248 41.1725 24.2995 41.1725C15.2383 41.1725 7.86712 33.907 7.86712 24.9783C7.86712 22.4893 8.44245 20.133 9.46315 18.0236L18.5821 33.964H28.1295L9.54743 1.47827H0V1.48064Z",
    fill: "url(#paint0_linear_5207_281184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3691 7.88396C33.6248 8.73688 40.0815 15.6436 40.0815 24.0115C40.0815 26.4729 39.5227 28.8061 38.5233 30.8993L25.3691 7.88396ZM23.5436 0.480646C19.7529 0.494901 16.1765 1.38824 13 2.95396L38.4486 47.4783H48L42.68 38.1695C45.6976 34.2302 47.4943 29.3288 47.4943 24.0091C47.4943 11.0463 36.8712 0.532917 23.7435 0.478271H23.5436V0.480646Z",
    fill: "url(#paint1_linear_5207_281184)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5207_281184",
    x1: 17.5,
    y1: 1.47827,
    x2: 17.5,
    y2: 48.4783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB40FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5207_281184",
    x1: 30.5,
    y1: 0.478271,
    x2: 30.5,
    y2: 47.4783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB40FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5207_281184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 49,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPurpleGradient);
export default __webpack_public_path__ + "static/media/logo-purple-gradient.2d462e25.svg";
export { ForwardRef as ReactComponent };